import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BillingManagementService } from 'src/service/billing-management.service';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { LanguageManagementService } from 'src/service/language-management.service';
import { InteractionType, LocalService, PageKey, Wrappers10 } from 'src/service/local.service';

@Component({
  selector: 'app-view-no-config-bill',
  templateUrl: './view-no-config-bill.component.html',
  styleUrl: './view-no-config-bill.component.scss'
})
export class ViewNoConfigBillComponent {
  lstSectionConfigKeys: string[] = ["table"]; ctryCode: string = ''; userId = ''; interactionType: InteractionType = InteractionType.None; wrapper: Wrappers10; businessId: string;

  maxBodyHeight = 0;

  constructor(public localService: LocalService, private route: ActivatedRoute, private languageManagementService: LanguageManagementService, private configurationManagementService: ConfigurationManagementService, private cdr: ChangeDetectorRef, private billingManagementService: BillingManagementService, private router: Router) {
  }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType;
      this.configurationManagementService.ensurePageActions(PageKey.ViewNoConfigureBill);
      this.localService.saveUrl();
      this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType);
      this.userId = routeParams.userId;
      this.ctryCode = routeParams.ctryCode;
      this.businessId = routeParams.businessId;
      this.onLoad();
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight(40);
    this.cdr.detectChanges();
  }

  onLoad() {
    this.billingManagementService.getNoConfigBillings(this.businessId, this.wrapper ? this.wrapper.paging : null).subscribe(result => {
      this.wrapper = result;
    });
  }

  onRoute(key: string) {
    this.router.navigate(['/create-no-config-bill' + this.localService.basicParamsString, this.businessId, key]);
  }
}
